import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Col, Input, message, Modal, Row } from "antd"
import { Table } from "~/components"
import dayjs from "dayjs"
import { useApi } from "~/hooks"
import { debounce } from "lodash"
import React, { useEffect, useMemo, useRef } from "react"
import { useSetState } from "react-use"
import { removeCamera } from "~/services/apis"
import Camera from "~/containers/camera"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"

const DEFAULT_PARAMS = {
  search: "",
  page: 1,
  limit: 10,
}

const CamerasPage = () => {
  const history = useHistory()
  const location = useLocation()
  const qs = queryString.parse(location.search)
  const [params, setParams] = useSetState(Object.keys(qs)?.length > 0 ? qs : { ...DEFAULT_PARAMS })
  const api = `
    query($params: FetchDto) {
      cameras(fetch: $params) {
        id
        name
        imageUrl
        hdViewUrl
        sdViewUrl
        projectId
        groupId
      }
    }
  `
  const response = useApi(api, {
    params: {
      search: params?.search,
      limit: params?.limit && +params.limit,
      page: params?.page && +params.page,
    },
  })

  useEffect(
    () => history.replace(`${location.pathname}?${queryString.stringify(params)}`),
    // eslint-disable-next-line
    [params],
  )

  const parsedData = useMemo(() => {
    const { data, error } = response
    const headers = data?.headers

    return {
      error,
      data: data?.data?.cameras,
      meta: (headers && JSON.parse(headers.get("meta"))) || {},
    }
  }, [response])

  const columns = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      className: "c-p",
      width: 400,
      render: (_, record) => {
        return (
          <Row gutter={8} style={{ flexDirection: "row", width: 400 }}>
            <Col>
              <img
                alt={"device-thumbnail"}
                style={{ width: 70, height: 70 }}
                src={
                  record?.imageUrl ||
                  "data:image/png;base64,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"
                }
              />
            </Col>
            <Col>
              <div style={{ fontWeight: 600, color: "var(--black)" }}>{record?.name}</div>
              <div className={"text-ellipsis"} style={{ width: 300, color: "var(--black)" }}>
                ID: {record?.id}
              </div>
            </Col>
          </Row>
        )
      },
    },
    {
      title: "Created at",
      key: "createdAt",
      dataIndex: "createdAt",
      className: "c-p",
      render: (value) => dayjs(value).format("MM/DD/YYYY"),
    },
    {
      title: "Updated at",
      key: "updatedAt",
      dataIndex: "updatedAt",
      className: "c-p",
      render: (value) => dayjs(value).format("MM/DD/YYYY"),
    },
    {
      title: "Action",
      width: 100,
      dataIndex: "action",
      key: "action",
      className: "c-p p-0",
      render: function render(_, record) {
        return (
          <Button
            size="small"
            type="danger"
            style={{ display: "flex", flex: 1 }}
            onClick={(e) => {
              e.stopPropagation()
              confirmDelete(record.id)
            }}
          >
            Delete
          </Button>
        )
      },
    },
  ]

  const debounceChange = debounce((search) => {
    setParams({ search, page: 1 })
  }, 500)

  const handleDelete = (id) => {
    removeCamera(id).then(() => {
      message.success("Success")
      hideCamera()
      response.mutate(api)
    })
  }

  const confirmDelete = (id) => {
    Modal.confirm({
      title: "Delete Camera",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => handleDelete(id),
    })
  }

  //edit camera
  const viewCamera = useRef()
  const {
    show: showCamera,
    hide: hideCamera,
    CameraDrawer,
  } = Camera.useDrawer({
    camera: viewCamera.current,
    onOk: () => response.mutate(api),
    onRemove: () => {
      hideCamera()
      response.mutate(api)
    },
  })

  return (
    <div>
      <Row style={{ marginBottom: 16 }} justify={"space-between"}>
        <Col span={10}>
          <Input
            defaultValue={params?.search}
            onChange={(e) => debounceChange(e.target.value)}
            placeholder={"Search by name....."}
            allowClear={true}
          />
        </Col>
        <Col>
          <Button onClick={showCamera} type={"primary"}>
            <PlusOutlined />
            Add new camera
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            loading={response.isValidating}
            rowKey={"id"}
            columns={columns}
            dataSource={parsedData?.data}
            scroll={{
              x: columns.reduce((acc, col) => {
                acc += col.width || 100

                return acc
              }, 300),
              scrollToFirstRowOnChange: true,
            }}
            onRow={(record) => ({
              onClick: () => {
                history.push(`/cameras/${record?.id}`)
              },
            })}
            pagination={{
              total: parsedData?.meta?.totalDocs,
              pageSize: params?.limit,
              showSizeChanger: false,
              hideOnSinglePage: true,
              onChange: (page) => setParams({ page }),
              current: Number(params?.page || 1),
            }}
          />
        </Col>
      </Row>
      <CameraDrawer />
    </div>
  )
}

export default CamerasPage
